import { render } from "./BasketballJersey_3_back.vue?vue&type=template&id=64775a0b&scoped=true"
import script from "./BasketballJersey_3_back.vue?vue&type=script&lang=js"
export * from "./BasketballJersey_3_back.vue?vue&type=script&lang=js"

import "./BasketballJersey_3_back.vue?vue&type=style&index=0&id=64775a0b&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64775a0b"]])

export default __exports__